export default __webpack_public_path__ + "static/media/70.01c38e49.png";